import { defaultTheme } from 'react-admin'

const desktopTypography = {
  typography: {
    fontSize: 16,
    h4: {
      fontSize: 1,
      color: '#fff7e1'
    },
    h6: {
      fontSize: 16,
      fontWeight: 700
    },
    subtitle1: {
      fontSize: 14,
      fontWeight: 700
    },
    caption: {
      fontSize: 14,
      fontWeight: 700
    },
    body1: {
      fontSize: 16,
      fontWeight: 700
    },
    button: {
      fontSize: 16,
      fontWeight: 700
    }
  }
}
export const desktopTtheme = {
  ...defaultTheme,
  ...desktopTypography,
  palette: {
    primary: {
      main: '#FFF'
    },
    background: {
      paper: '#fff7e1',
      default: '#FFF'
    }
  }
}
export const adminTheme = {
  ...defaultTheme,
  ...desktopTypography
}
export const otherTheme = {
  ...defaultTheme,
  palette: {
    primary: {
      main: '#FFF'
    },
    background: {
      paper: '#fff7e1',
      default: '#FFF'
    }
  },
  typography: {
    fontSize: 16,
    h6: {
      fontSize: 18,
      fontWeight: 700
    },
    subtitle1: {
      fontSize: 20,
      fontWeight: 700
    },
    caption: {
      fontSize: 16,
      fontWeight: 700
    },
    body1: {
      fontSize: 20,
      fontWeight: 700
    },
    button: {
      fontSize: 18,
      fontWeight: 700
    }
  }
}
